import React from 'react';
import classNames from 'classnames';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import * as AppState from '../../../../AppState';
import DropdownButton from '../../../Shared/DropdownButton';
import Colors from '../../../Shared/Colors';

import './PropertyTypeButton.scss';

const indicatorStyle = {
	height: '14px',
	width: '14px',
	marginBottom: '-2px',
	display: 'inline-flex',
	borderRadius: '100%',
	border: '1px solid',
	borderColor: Colors.brand500
};

const recentlySoldStyle = {
	backgroundColor: Colors.slate300,
	borderColor: Colors.slate500
};

const forSaleStyle = {
	backgroundColor: '#3BB1BC',
	borderColor: '#3BB1BC'
};

const PropertyTypeButton = (props: { wrapperClass?: string }) => {
	const gsFilters = useRecoilValue(AppState.gsFilters);
	const gsIsMobile = useRecoilValue(AppState.gsIsMobile);
	const setGsFilters = useSetRecoilState(AppState.gsFilters);

	const ForSale = (
		<div className="text-truncate">
			<span className="flex-shrink-0 me-2" style={{...indicatorStyle, ...forSaleStyle}} />
      For Sale
		</div>
	);

	const RecentlySold = (
		<React.Fragment>
			<span className="me-2" style={{...indicatorStyle, ...recentlySoldStyle}} />
      Recently Sold
		</React.Fragment>
	);

	const CapCenterRealty = (
		<React.Fragment>
			<span className="bg-primary flex-shrink-0 me-2" style={{...indicatorStyle}} />
      CapCenter Realty
		</React.Fragment>
	);

	function handleClick(value: string) {
		setGsFilters({ ...gsFilters, propertyType: value });
	}

	return (
		<DropdownButton
			defaultValue={gsFilters.propertyType === 'ForSale' ? ForSale : (gsFilters.propertyType === 'RecentlySold' ?  RecentlySold : CapCenterRealty)}
			color="gray"
			variant="outline"
			id="homesearchPropertyTypeDropdown"
			className={classNames(
				'cc-btn--gray',
				'cc-btn cc-btn--outline cc-btn--reset-text justify-content-center text-capitalize cc-btn--navbar homesearch-filters__cc-btn--property-type',
        gsIsMobile && 'h-100'
      )}
			wrapperClass={props.wrapperClass}
			options={
				<React.Fragment>
					<li
						role="menuitem"
						tabIndex={0}
						className="d-flex align-items-center cursor--pointer dropdown-item"
						onClick={() => handleClick('ForSale')}
					>
						{ForSale}
					</li>
					<li
						role="menuitem"
						tabIndex={0}
						className="d-flex align-items-center cursor--pointer dropdown-item"
						onClick={() => handleClick('RecentlySold')}
					>
						{RecentlySold}
					</li>
					<li
						role="menuitem"
						tabIndex={0}
						className="d-flex align-items-center cursor--pointer dropdown-item"
						onClick={() => handleClick('CapCenterRealty')}
					>
						{CapCenterRealty}
					</li>
				</React.Fragment>
			}
		/>
	);
};

export default PropertyTypeButton;
